
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linkme",
      function () {
        return require("private-next-pages/linkme.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linkme"])
      });
    }
  